import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/web/src/components/DatoLink/DatoLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/Header/HeaderBannerLocale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMenu"] */ "/opt/render/project/src/apps/web/src/components/Header/HeaderDropdownMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/Header/HeaderLangSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMobileDropdownMenu"] */ "/opt/render/project/src/apps/web/src/components/Header/HeaderMobileDropdownMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderSearchBar"] */ "/opt/render/project/src/apps/web/src/components/Header/HeaderSearchBar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
